import dayjs from 'dayjs'
import React from 'react'

export default function useColumn() {
    const column = {
        "event": [
            { id: "Sl NO.", label: "Sl NO", renderCell: (_, index) => index + 1 },
            { id: "Event Id", label: "Event Id", renderCell: (row) => row?.event_id },
            { id: "Event Name ", label: "Event Name", renderCell: (row) => row?.event_name },
            { id: "Vendor Name ", label: "Vendor Name", renderCell: (row) => row?.vendor_name || "-" },
            { id: "total_gst", label: "Total gst" },
            { id: "total_sale", label: "Total  Sale" },
            { id: "Platform fee Collected ", label: "Platform fee Collected ", renderCell: (row) => row?.total_platform_fee, width: 200 },
            { id: "Settlement Amount", label: "Settlement Amount", renderCell: (row) => row?.total_ticket_amount || "-" },
        ],
        "credit": [
            { id: "Sl NO.", label: "Sl NO", renderCell: (_, index) => index + 1 },
            { id: "vendor_name", label: "Vendor Name" },
            { id: "Credits QTY ", label: "Credits QTY", renderCell: (row, index) => row?.total_credits },
            { id: "Credits Amount", label: "Credits Amount", renderCell: (row, index) => row?.total_amount, width: 200 },
            { id: "GST Collected", label: "GST Collected", renderCell: (row, index) => row?.total_gst },
            { id: "Total Amount", label: "Total Amount", renderCell: (row, index) => row?.total_amount + row?.total_gst },
        ],
        "invoice": [
            { id: "Sl NO.", label: "Sl NO", renderCell: (_, index) => index + 1 },
            { id: "vendor_name", label: "Vendor Name" },
            { id: "Payout Type", label: "Payout Type", renderCell: (row, index) => row?.invoice_type },
            { id: "Amount", label: "Amount", renderCell: (row, index) => row?.total_amount - row?.total_gst, width: 200 },
            { id: "total_gst", label: "GST Collected" },
            { id: "total_amount", label: "Total Amount", },
        ],
    }

    return { column }
}
